module.exports = __webpack_public_path__ + "AvantGardeBookBT.ad81fd1b50a4ef839998.ttf";


//////////////////
// WEBPACK FOOTER
// C:/Users/beyn/Documents/GitLab/spinmatic-casino/src/assets/fonts/AvantGardeITCTT/AvantGardeBookBT.ttf
// module id = ../../../../../src/assets/fonts/AvantGardeITCTT/AvantGardeBookBT.ttf
// module chunks = styles